export default __webpack_public_path__ + "static/media/printer.62db277f.svg";